import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Add a new material to the catalog
 * @primary Material form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/materials/new")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
